/**
 * Strict integer parsing for the campaign form's numeric inputs. `Number.parseInt` silently
 * truncates decimals ("1.5" -> 1) and accepts things a plain count shouldn't ("1e2" -> 1), while
 * returning NaN for benign in-progress typing like "-" or "". Number(...) + Number.isInteger
 * rejects all of that instead of coercing it, so invalid/incomplete input is treated the same as
 * blank rather than silently submitted as a different number.
 */
export function parseStrictInteger(raw: string, min: number): number | undefined {
  const trimmed = raw.trim();
  if (!trimmed) {
    return undefined;
  }
  const value = Number(trimmed);
  return Number.isInteger(value) && value >= min ? value : undefined;
}
